export const initialLidState = {
    type: 'B125',
    collar: 'beveled',
    fill: 'anthracite',
    manholes: [],
    blockOuts: [],
    circularBlockOuts: []
}
